import http from "./http";
import {useRequest} from "ahooks";

let apiPath = {
  qryNoticePage: '/cms/cmsNotice/qryNoticePage',
  getNoticeInfo: '/cms/cmsNotice/getNoticeInfo',
};

/**
 * 获取商城资讯
 * @param query
 * @returns {{result: unknown, getNews: (...params: any[]) => Promise<unknown>, loading: boolean, error: Error}}
 */
export const useQryNoticePage = (query) => {
  const { data, runAsync, error, loading } = useRequest(() => {
    return http({
      url: apiPath.qryNoticePage,
      method: 'get',
      data: query || {}
    });
  }, { manual: true });
  
  return {
    result: data || {},
    loading,
    error,
    getNews: runAsync,
  };
};

export const useGetNewsDetail = (id) => {
  const { data, runAsync, error, loading } = useRequest(() => {
    return http({
      url: apiPath.getNoticeInfo + '?noticeId=' + id + '&flag=0',
      method: 'get',
      data:  {}
    });
  }, { manual: true });
  
  return {
    result: data || {},
    loading,
    error,
    getNewsDetail: runAsync,
  };
};
